// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hO7G","field":"styles_field__3Ed94","fieldCol":"styles_fieldCol__35G5N","diffCol":"styles_diffCol__1WORO","diff":"styles_diff__2y7wJ"};